export const numberRegex=/^-?\d+$/;